import { render, staticRenderFns } from "./MTest.vue?vue&type=template&id=2e74a271&scoped=true"
import script from "./MTest.vue?vue&type=script&lang=js"
export * from "./MTest.vue?vue&type=script&lang=js"
import style0 from "./MTest.vue?vue&type=style&index=0&id=2e74a271&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74a271",
  null
  
)

export default component.exports